<template>
  <v-container>
    <v-container>
      <div>
        <v-row class="pt-6">
          <v-col cols="12">
            <h1 class="text-primary">Comparative Country Tables (TAB)</h1>
          </v-col>
          <v-col cols="12">
            <h4 v-if="tab == 1" class="text-primary">
              Compare expected annual performance of EM financial indicators
              across countries under different scenarios. For specific
              instructions, look
              <a href="#" @click="dialog = true">Here</a>.
            </h4>
            <h4 v-if="tab == 2" class="text-primary">
              Compare short-term responses of BOLSA, NER, and CDS to a common
              international shock of your own design. For specific instructions,
              look <a href="#" @click="dialog = true">Here</a>.
            </h4>

            <div>
              <v-dialog v-model="dialog" width="auto" scrollable>
                <v-card>
                  <v-card-text style="height: 400px; overflow-y: scroll">
                    <div>
                      <h4 v-if="tab == 1" class="text-primary">
                        The table you see on the screen has
                        consensus forecasts for the international macro variables our
                        model uses as inputs. Click
                        <b>Apply</b> and choose an endogenous variable in the next
                        table to see how the variable you choose is
                        forecasted to change between weeks T and T+52 in all the
                        countries of the platform if the consensus international
                        scenario materializes. Change the inputs and click <b>Apply</b>
                        to see how the results are modified. Compare the
                        results to assess how changes in international
                        conditions affect local financial markets differentially
                        depending on the country.
                        <br />
                        <br />
                        Important: H2F2 is a proprietary product of Janus4cast
                        LLC for which a USPTO patent is pending. Reproducing
                        graphical and/or numerical results obtained by using
                        this tool require citing
                        <a href="http://www.janus4cast.com"
                          >www.Janus4cast.com</a
                        >
                        as the primary source.
                      </h4>
                      <h4 v-if="tab == 2" class="text-primary">
                        The numbers you see on the first column of the table
                        (week T) describe current international macroeconomic
                        conditions. Model an international shock of your own
                        design by changing those numbers in the second column (week T+1)
                        . Click <b>Apply</b>
                        and choose an endogenous variable to see the results.
                        The platform will devolve, for all countries at once,
                        week T+1 forecasts of the endogenous variable chosen, 
                        along with the percentage change between T and
                        T+1. Compare the results to assess
                        differential short-term country vulnerability to a common
                        international shock.
                        <br />
                        <br />
                        Important: H2F2 is a proprietary product of Janus4cast
                        LLC for which a USPTO patent is pending. Reproducing
                        graphical and/or numerical results obtained by using
                        this tool require citing
                        <a href="http://www.janus4cast.com"
                          >www.Janus4cast.com</a
                        >
                        as the primary source.
                      </h4>
                    </div>
                  </v-card-text>
                  <v-card-actions class="justify-end">
                    <v-btn color="primary" @click="dialog = false">Close</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-tabs
                v-model="tab"
                color="primary"
                align-tabs="center"
                fixed-tabs
              >
                <v-tab :value="1">Medium-Term Performance</v-tab>
                <v-tab :value="2">Vulnerability to Shocks</v-tab>
              </v-tabs>
              <v-window v-model="tab">
                <v-window-item :value="1">
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12"></v-col>
                      <v-col cols="12">
                        <v-table calculate-widths>
                          <thead>
                            <tr>
                              <th
                                v-for="item in header2"
                                v-bind:key="item"
                                class="text-center"
                              >
                                {{ headerLabel(item) }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, indexD) in desserts2"
                              :key="item.name"
                            >
                              <td
                                v-if="item.header"
                                class="text-left"
                                style="
                                  background-color: var(--bg-2);
                                  font-family: var(--f-body);
                                  color: var(--text);
                                  font-weight: bold;
                                  font-size: 16px !important;
                                  width: 150px;
                                "
                              >
                                {{ item.name }}
                              </td>
                              <td
                                v-if="!item.header"
                                class="text-left; font-size: 16px !important;font-family: var(--f-body);"
                              >
                                <div style="width: 225px">
                                  {{ item.name }}
                                </div>
                              </td>
                              <td
                                v-for="a in item.data"
                                v-show="item.header"
                                v-bind:key="a"
                                class="text-center"
                                style="background-color: var(--bg-2)"
                              ></td>
                              <td
                                v-for="(value, index) in item.data"
                                v-show="!item.header"
                                v-bind:key="value"
                                class="text-center"
                              >
                                <input
                                  with="50%"
                                  type="number"
                                  step="0.1"
                                  style="text-align: center; width: 120px"
                                  :value="item.data[index]"
                                  :disabled="index == 0 || item.disable"
                                  @change="updateValue($event, indexD, index)"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </v-table>
                      </v-col>
                    </v-row>
                    <v-row justify="end">
                      <v-col cols="12"></v-col>
                      <v-btn
                        v-show="!getVulnerabilityLoading"
                        @click="sendData"
                        rounded
                        class="elevation-0 mr-3"
                        color="primary"
                        >Apply</v-btn
                      >
                      <v-progress-circular
                        v-show="getVulnerabilityLoading"
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </v-row>
                    <v-row v-show="showResult" align="end">
                      <v-col cols="12"></v-col>
                      <v-col cols="12" xl="12" md="12" class="pt-0">
                        <v-row>
                          <v-col cols="6" xl="3" md="4">
                            <select
                              v-show="!table"
                              name="LeaveType"
                              @change="onChange2($event)"
                              class="form-control minimal"
                              v-model="value3"
                            >
                              <option
                                v-for="item in value3Opcions"
                                :value="item"
                                v-bind:key="item"
                              >
                                {{ item }}
                              </option>
                            </select>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-card contained-text variant="outlined">
                          <v-table calculate-widths>
                            <thead>
                              <tr>
                                <th class="text-center">Country</th>
                                <th
                                  v-for="item in header3"
                                  v-bind:key="item"
                                  class="text-center"
                                >
                                  {{ headerLabel(item) }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="item in desserts3" :key="item.name">
                                <td
                                  v-if="item.header"
                                  class="text-left"
                                  style="
                                    background-color: var(--bg-2);
                                    font-family: var(--f-body);
                                    color: var(--text);
                                    font-weight: bold;
                                    font-size: 16px !important;
                                  "
                                >
                                  {{ item.name }}
                                </td>
                                <td
                                  v-if="!item.header"
                                  class="text-left; font-size: 16px !important;font-family: var(--f-body);"
                                >
                                  {{ item.name }}
                                </td>
                                <td
                                  v-for="a in item.data"
                                  v-show="item.header"
                                  v-bind:key="a"
                                  class="text-center"
                                  style="background-color: var(--bg-2)"
                                ></td>
                                <td
                                  v-for="value in item.data"
                                  v-show="!item.header"
                                  v-bind:key="value"
                                  class="text-center"
                                >
                                  {{
                                    new Intl.NumberFormat("en-US").format(value)
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </v-table>
                        </v-card>
                      </v-col>
                      <v-col cols="2" v-show="header3.length > 0">
                        <v-btn
                          @click="saveCsv()"
                          rounded
                          class="elevation-0"
                          color="primary"
                          >download</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-window-item>
                <v-window-item :value="2">
                  <v-container fluid>
                    <v-row>
                      <!--<v-col cols="2">
                        <select
                          name="LeaveType"
                          class="form-control minimal"
                          v-model="value2"
                        >
                          <option
                            v-for="item in getcontriesConsensusFilter"
                            :value="item"
                            v-bind:key="item.name"
                          >
                            {{ item.name }}
                          </option>
                        </select> </v-col
                      >-->
                      <v-col cols="12"></v-col>
                      <v-col cols="12">
                        <v-table calculate-widths>
                          <thead>
                            <tr>
                              <th
                                v-for="item in header2"
                                v-bind:key="item"
                                class="text-center"
                              >
                                {{ headerLabel(item) }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, indexD) in desserts2"
                              :key="item.name"
                            >
                              <td
                                v-if="item.header"
                                class="text-left"
                                style="
                                  background-color: var(--bg-2);
                                  font-family: var(--f-body);
                                  color: var(--text);
                                  font-weight: bold;
                                  font-size: 16px !important;
                                  width: 150px;
                                "
                              >
                                {{ item.name }}
                              </td>
                              <td
                                v-if="!item.header"
                                class="text-left; font-size: 16px !important;font-family: var(--f-body);"
                              >
                                {{ item.name }}
                              </td>
                              <td
                                v-for="a in item.data"
                                v-show="item.header"
                                v-bind:key="a"
                                class="text-center"
                                style="background-color: var(--bg-2)"
                              ></td>
                              <td
                                v-for="(value, index) in item.data"
                                v-show="!item.header"
                                v-bind:key="value"
                                class="text-center"
                              >
                                <input
                                  with="50%"
                                  type="number"
                                  step="0.1"
                                  style="text-align: center; width: 120px"
                                  :value="item.data[index]"
                                  :disabled="index == 0 || item.disable"
                                  @change="updateValue($event, indexD, index)"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </v-table>
                      </v-col>
                    </v-row>
                    <v-row justify="end">
                      <v-col cols="12"></v-col>
                      <v-btn
                        v-show="!getVulnerabilityLoading"
                        @click="sendData"
                        rounded
                        class="elevation-0 mr-3"
                        color="primary"
                        >Apply</v-btn
                      >
                      <v-progress-circular
                        v-show="getVulnerabilityLoading"
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </v-row>
                    <v-row v-show="showResult" align="end">
                      <v-col cols="12"></v-col>
                      <v-col cols="12" xl="12" md="12" class="pt-0">
                        <v-row>
                          <v-col cols="6" xl="3" md="4">
                            <select
                              v-show="!table"
                              name="LeaveType"
                              @change="onChange2($event)"
                              class="form-control minimal"
                              v-model="value3"
                            >
                              <option
                                v-for="item in value3Opcions"
                                :value="item"
                                v-bind:key="item"
                              >
                                {{ item }}
                              </option>
                            </select>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-card contained-text variant="outlined">
                          <v-table calculate-widths>
                            <thead>
                              <tr>
                                <th class="text-center">Country</th>
                                <th
                                  v-for="item in header3"
                                  v-bind:key="item"
                                  class="text-center"
                                >
                                  {{ headerLabel(item) }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="item in desserts3" :key="item.name">
                                <td
                                  v-if="item.header"
                                  class="text-left"
                                  style="
                                    background-color: var(--bg-2);
                                    font-family: var(--f-body);
                                    color: var(--text);
                                    font-weight: bold;
                                    font-size: 16px !important;
                                  "
                                >
                                  {{ item.name }}
                                </td>
                                <td
                                  v-if="!item.header"
                                  class="text-left; font-size: 16px !important;font-family: var(--f-body);"
                                >
                                  {{ item.name }}
                                </td>
                                <td
                                  v-for="a in item.data"
                                  v-show="item.header"
                                  v-bind:key="a"
                                  class="text-center"
                                  style="background-color: var(--bg-2)"
                                ></td>
                                <td
                                  v-for="value in item.data"
                                  v-show="!item.header"
                                  v-bind:key="value"
                                  class="text-center"
                                >
                                  {{
                                    new Intl.NumberFormat("en-US").format(value)
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </v-table>
                        </v-card>
                      </v-col>
                      <v-col cols="2" v-show="header3.length > 0">
                        <v-btn
                          @click="saveCsv()"
                          rounded
                          class="elevation-0"
                          color="primary"
                          >download</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-window-item>
              </v-window>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Country_table",
  data() {
    return {
      tab: null,
      header: [],
      desserts: [],
      variables: [
        { name: "Local CDS", value: "Local CDS" },
        { name: "Local NER", value: "Local NER" },
        { name: "Local SE", value: "Local SE" },
      ],
      value: { name: "Local CDS", value: "Local CDS" },
      header2: [],
      desserts2: [],
      value2: {
        consensusReport: "Brazil",
        consensusReportFilter: true,
        consensusReportResult: "Brazil",
        dataVisualizationFilter: true,
        forecastFilter: true,
        forecastTool: "Brazil",
        name: "Brazil",
      },
      header3: [],
      desserts3: [],
      value3Opcions: [],
      datajson: [],
      value3: null,
      dialog: false,
    };
  },
  computed: {
    ...mapGetters([
      "getPerformanceToolResult",
      "getVulnerability",
      "getVulnerabilityLoading",
      "getDataVulnerabilityApply",
      "getcontriesConsensus",
      "getUrlVulnerability",
      "getPerformance",
      "getTab",
    ]),
    getcontriesConsensusFilter: function () {
      return this.getcontriesConsensus.filter((i) => i.forecastFilter === true);
    },
    showResult: function () {
      return Object.keys(this.datajson).length > 0;
    },
  },
  methods: {
    // "NOW WEEK T" -> "Latest", "Q426" -> "Q4 2026"; other headers unchanged
    headerLabel(item) {
      if (item === "NOW WEEK T") return "Latest";
      const q = /^Q([1-4])(\d{2})$/.exec(item);
      return q ? `Q${q[1]} 20${q[2]}` : item;
    },
    ...mapActions([
      "setDataPerformanceToolResult",
      "setDataVulneravility",
      "setVulneravilityApply",
      "setCountriesConsensus",
      "exportExcelVulnerability",
      "setPerformaceApply",
      "setDataPerformance",
      "exportExcelPerfomance",
    ]),
    onChange() {
      this.setDataPerformanceToolResult(this.value.value);
    },
    onChange2() {
      let data = this.datajson[this.value3];
      if (Object.keys(data).length > 0) {
        this.header3 = Object.keys(data);
        let newData = [];

        for (
          let j = 0;
          j < Object.keys(data[Object.keys(data)[0]]).length;
          j++
        ) {
          let obj = {};
          obj.name = Object.keys(data[Object.keys(data)[0]])[j];
          obj.data = [];
          obj.header = false;
          for (let i = 0; i < Object.keys(data).length; i++) {
            obj.data.push(
              data[Object.keys(data)[i]][
                Object.keys(data[Object.keys(data)[i]])[j]
              ]
            );
          }
          newData.push(obj);
        }
        this.desserts3 = newData;
      }
    },
    updateValue(val, indexD, index) {
      this.desserts2[indexD].data[index] = val.target.value;
    },
    sendData() {
      let data = {
        country: this.value2.forecastTool,
        data: [],
      };
      for (let i = 0; i < this.desserts2.length; i++) {
        if (!this.desserts2[i].header) {
          let item = { key: this.desserts2[i].name, values: [] };
          for (let j = 0; j < this.desserts2[i].data.length; j++) {
            item.values.push({
              header: this.header2[j + 1],
              value: this.desserts2[i].data[j],
            });
          }
          data.data.push(item);
        }
      }
      if (this.tab == 2)
        this.setVulneravilityApply(JSON.stringify(data).replaceAll("\\", ""));
      else this.setPerformaceApply(JSON.stringify(data).replaceAll("\\", ""));
    },
    saveCsv() {
      let variables = this.value3Opcions;
      let data = this.datajson;
      if (this.tab == 1) {
        this.exportExcelPerfomance({
          data: JSON.stringify(data),
          variables: variables,
        });
      } else {
        this.exportExcelVulnerability({
          data: JSON.stringify(data),
          variables: variables,
        });
      }
    },
  },
  mounted() {
    this.setDataPerformanceToolResult(this.value.value);
    this.tab = this.getTab;
  },
  watch: {
    tab: function (val) {
      this.desserts2 = [];
      this.header2 = [];
      this.datajson = [];
      this.setCountriesConsensus();
      if (val == 1) {
        this.setDataPerformance();
      } else {
        this.setDataVulneravility();
      }
    },
    getPerformanceToolResult: function (val) {
      let data = JSON.parse(val);
      this.desserts = [];
      this.header = [];
      if (Object.keys(data).length > 0) {
        this.header = Object.keys(data);
        let newData = [];
        for (let j = 0; j < Object.keys(data["Country"]).length; j++) {
          let obj = {};
          obj.name = data["Country"][j];
          obj.data = [];
          obj.header = false;

          for (let i = 0; i < Object.keys(data).length; i++) {
            if (i != 0) {
              obj.data.push(data[Object.keys(data)[i]][j]);
            }
            //obj.data.push(data[Object.keys(data)[i]][j].toFixed(2));
          }
          newData.push(obj);
        }
        this.desserts = newData;
      }
    },
    getVulnerability: function (val) {
      let data = JSON.parse(val);
      this.desserts2 = [];
      this.header2 = [];
      if (Object.keys(data).length > 0) {
        this.header2 = Object.keys(data);
        let newData = [];
        for (let j = 0; j < Object.keys(data["Indicator"]).length; j++) {
          let obj = {};
          obj.name = data["Indicator"][j];
          obj.data = [];
          obj.header = false;

          for (let i = 0; i < Object.keys(data).length; i++) {
            if (i != 0) {
              obj.data.push(data[Object.keys(data)[i]][j]);
            }
            //obj.data.push(data[Object.keys(data)[i]][j].toFixed(2));
          }
          newData.push(obj);
        }
        this.desserts2 = newData;
      }
    },
    getPerformance: function (val) {
      let data = JSON.parse(val);
      console.log(data);
      this.desserts2 = [];
      this.header2 = [];
      console.log(Object.keys(data));
      if (Object.keys(data).length > 0) {
        this.header2 = Object.keys(data);
        this.header2.unshift("Indicator");
        let newData = [];
        console.log(data["NOW WEEK T"]);

        for (let i = 0; i < Object.keys(data["NOW WEEK T"]).length; i++) {
          let obj = {};
          obj.name = Object.keys(data["NOW WEEK T"])[i];
          obj.data = [];
          obj.header = false;
          for (let j = 0; j < Object.keys(data).length; j++) {
            obj.data.push(
              data[Object.keys(data)[j]][Object.keys(data["NOW WEEK T"])[i]]
            );
          }
          newData.push(obj);
        }

        this.desserts2 = newData;
      }
    },
    getDataVulnerabilityApply: function (val) {
      val = val.replaceAll("'{", "{");
      val = val.replaceAll("}'", "}");
      val = val.replaceAll("'", '"');
      let data = JSON.parse(val);
      this.desserts3 = [];
      this.header3 = [];
      if (Object.keys(data).length > 0) {
        this.value3Opcions = Object.keys(data);
        this.datajson = data;
      }
    },
    value3Opcions: function (val) {
      this.value3 = val[0];
      let data = this.datajson[this.value3];
      if (Object.keys(data).length > 0) {
        this.header3 = Object.keys(data);
        let newData = [];

        for (
          let j = 0;
          j < Object.keys(data[Object.keys(data)[0]]).length;
          j++
        ) {
          let obj = {};
          obj.name = Object.keys(data[Object.keys(data)[0]])[j];
          obj.data = [];
          obj.header = false;
          for (let i = 0; i < Object.keys(data).length; i++) {
            obj.data.push(
              data[Object.keys(data)[i]][
                Object.keys(data[Object.keys(data)[i]])[j]
              ]
            );
          }
          newData.push(obj);
        }
        this.desserts3 = newData;
      }
    },
    getcontriesConsensus: function (val) {
      this.value = val[0];
    },
    getUrlVulnerability: function (val) {
      if (val != "") {
        window.open(val, "_blank");
      }
    },
  },
};
</script>
<style scoped>
table > thead > tr > th {
  font-family: var(--f-body);
  color: var(--text);
  font-weight: bold;
  font-size: 16px !important;
  width: 100px !important;
}

td:nth-child(1) {
  width: 40%;
}

table tbody tr td {
  font-family: var(--f-body);
  color: var(--text);
  font-weight: bold;
}

table > tbody > tr > td:nth-child(1) {
  position: sticky;
  left: 0;
  background: var(--bg-2);
  width: 100px;
}
table > thead > tr > th:nth-child(1) {
  position: sticky;
  left: 0;
  background: var(--bg-2);
}
v-input__details {
  margin: 0%;
}

select.minimal {
  background-image: linear-gradient(45deg, transparent 50%, gray 50%),
    linear-gradient(135deg, gray 50%, transparent 50%),
    linear-gradient(to right, #ccc, #ccc);
  background-position: calc(100% - 20px) calc(1em + 2px),
    calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
}

select.minimal:focus {
  background-image: linear-gradient(45deg, green 50%, transparent 50%),
    linear-gradient(135deg, transparent 50%, green 50%),
    linear-gradient(to right, #ccc, #ccc);
  background-position: calc(100% - 15px) 1em, calc(100% - 20px) 1em,
    calc(100% - 2.5em) 0.5em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
  border-color: green;
  outline: 0;
}

select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #000;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
